/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HCircleIcon24Solid = forwardRef('UiMenuDots3HCircleIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm5.25-8.424a1.576 1.576 0 1 0 0-3.152 1.576 1.576 0 0 0 0 3.152ZM13.574 12a1.574 1.574 0 1 1-3.148 0 1.574 1.574 0 0 1 3.148 0ZM6.75 13.573a1.573 1.573 0 1 0 0-3.146 1.573 1.573 0 0 0 0 3.146Z" })));
});
